import { useRef } from 'react';
import { cn } from '@anytag/shared-utils';
import { File } from './file';
import { MessageType } from './types';
import { CopyButton } from './copy-button';
import { MarkdownReader } from './markdown-reader';
import { RegenerateButton } from './regenerate-button';
import { ChatTypingIndicator } from './typing-indicator';

export interface MessageProps {
  className?: string;
  onRegenerate?: () => void;
  message?: MessageType | null;
}
export const Message = ({ message, className, onRegenerate }: MessageProps) => {
  const textRef = useRef<HTMLDivElement>(null);

  const isLeft = message?.position === 'left';
  const isTyping = message?.typing;

  return message ? (
    <div className={cn(styles.wrapper(isLeft), isTyping && 'w-full', className)}>
      {message.file ? (
        <File file={message.file} />
      ) : (
        <div className={cn(styles.text(isLeft))}>
          {isLeft && isTyping ? <ChatTypingIndicator /> : <MarkdownReader ref={textRef} value={message.text} />}

          {!isTyping && (message.copyable || (message.regenerative && !!onRegenerate)) ? (
            <div className="invisible mt-1.25 flex items-center justify-end gap-2.5 group-hover/text:visible">
              {message.copyable ? (
                <CopyButton
                  copyText={textRef.current?.textContent || textRef.current?.innerText} // Get Markdown text without HTML tags
                />
              ) : null}

              {message.regenerative && onRegenerate ? <RegenerateButton onRegenerate={onRegenerate} /> : null}
            </div>
          ) : null}
        </div>
      )}
    </div>
  ) : null;
};

const styles = {
  wrapper: (isLeft: boolean) => cn('box-border w-max max-w-full', isLeft ? 'self-start' : 'self-end'),
  text: (isLeft: boolean) =>
    cn(
      'group/text box-border rounded-xl px-4 py-2 text-lg leading-6 whitespace-pre-line text-primary',
      isLeft ? 'bg-white px-2' : 'bg-black-10'
    )
};
